module.exports = __webpack_public_path__ + "static/media/logo_white.6b1fa6e7.png";